<template>
  <v-row>
    <v-dialog v-model="showDialog" scrollable max-width="650px" style="z-index: 1019;">
      <v-skeleton-loader v-if="loading" type="article, actions"></v-skeleton-loader>
      <v-card v-if="!loading">
        <v-card-title style="padding: 10px 0 0 10px">
          <v-col cols="12" class="py-0 pl-0">
              <span class="d-block" style="font-size: 20px;">
                {{ title }}
              </span>
          </v-col>
          <v-col cols="12" class="py-0 pl-0">
              <span style="color: #616161;">
                {{ subtitle }}
              </span>
          </v-col>
        </v-card-title>
        <v-card-text style="padding-bottom: 0">
          <v-container>
            <v-row>
              <v-col cols='12'>
                <TargetManager 
                  ref="TargetManager"
                  :types="types"
                  :filterByProfile="false"
                  :selectedIds="selectedIds"
                  :isProject="projectId ? true : false"
                  :targetLabel="targetLabel" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#185EA9" text @click="ok()" style="font-size: 0.9em; font-weight: 400">
            {{ $t("wkt.admin.common.dialog-buttons.save").toUpperCase() }}
          </v-btn>
          <v-btn text @click="showDialog = false" style="font-size: 0.9em; font-weight: 400">
            {{ $t("wkt.admin.common.dialog-buttons.cancel").toUpperCase()}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";
import TargetManager from "../../common/TargetManager.vue";
import gwt from '../../../api/gwt.js';

export default {
  name: "TargetManagerDialog",
  mixins: [BaseModule],
  props: ['title', 'subtitle', 'targetLabel'],
  components: {
    TargetManager
  },
  data() {
    return {
      showDialog: false,
      loading: false,
      projectId: null,
      selectedIds: null,
      msgCb: null,
      types: [],
      employeeIds: []
    };
  },
  methods: {
    open(selectedIds, projectId, msgCb) {
      this.selectedIds = selectedIds;
      this.projectId = projectId;
      this.msgCb = msgCb;
      
			this.types = [
				{ id: 0, name: this.$t('wkt.admin.employee-selector-window.target_company') },
				{ id: 1, name: this.$t('wkt.admin.employee-selector-window.target_group') },
				{ id: 3, name: this.$t('wkt.admin.employee-selector-window.target_employees') }
			];

      if (gwt.getSessionInformation().myTeam && gwt.getSessionInformation().myTeam.length > 0) {
				this.types.push({ id: 4, name: this.$t('wkt.admin.employee-selector-window.target_myteam') });
      }

      this.showDialog = true;
    },		
    ok() {
      this.showDialog = false;
      const employeeIds = this.$refs.TargetManager.getProjectEmployeeIds();
      if (employeeIds.length > 0 && this.msgCb) {
        this.msgCb(employeeIds);
      }
    }
  },
};
</script>
